import {
  Dialog,
  Box,
  Modal,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import IllustrationWrapper from '../../../v3/Illustrration/IllustrationWrapper';


const AnimationModal = ({
    open,
    onClose,
    sx = {},
    onAnimationComplete,
    loop = true, // Default value for loop
    animationData,
    title,
    subtitle,
    width = { xs: 400, md: 400 },
    buttonSx = { width: { xs: '100%', md: '100%' } },
    maxWidth = { xs: 400, md: 400 },
    minHeight = { xs: 'auto', md: 410 },
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    
  return (
    <Modal 
      open={open} 
      onClose={onClose}
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', m: 2 }}
    >
      <Box
        sx={{
          borderRadius: 2,
          textAlign: 'center',
          width: width,
          minHeight: minHeight,
          // maxWidth: maxWidth,
          p: 2,
          m: 0,
          gap: 4,
          backgroundColor: !isMobile ? '#ffffffd1' : '#ffffffd1',
          backdropFilter: 'blur(5px)',
          WebkitBackdropFilter: 'blur(5px)',
          // boxShadow: 24,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          ...sx
        }}
      >
      <Box sx={{ textAlign: 'center', justifyContent: 'center', display: 'flex', flexDirection: 'column', gap: 1 }}>
        <IllustrationWrapper
            titleVariant = 'h1'
            subtitleVariant = 'body1'
            animationData={animationData}
            loop={loop}
            onAnimationComplete={onAnimationComplete}
            title={title}
            subtitle={subtitle}
        />
      </Box>
      </Box>
    </Modal>
  );
};

export default AnimationModal;
